import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import DOMPurify from 'dompurify';
import { useTheme } from 'ThemeContext';
import {
  Content,
  Date,
  Image,
  Item,
  NextArrow,
  Option,
  PrevArrow,
  Select,
  SelectContainer,
  Table,
  Text,
  Title,
  Wrapper
} from './WidgetLessonPlan.style';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Plan from 'assets/Images/plan.svg';

const WidgetLessonPlan = ({ title = '', data = [] }) => {
  const theme = useTheme();
  const [groupIndex, setGroupIndex] = useState(0);
  const [sliderOptions] = useState({
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    arrows: true,
    infinite: true,
    speed: 2,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false
  });

  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <NextArrow onClick={onClick} theme={theme.widgetLessonPlan.arrow}>
        <FontAwesomeIcon icon={faAngleRight} />
      </NextArrow>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <PrevArrow onClick={onClick} theme={theme.widgetLessonPlan.arrow}>
        <FontAwesomeIcon icon={faAngleLeft} />
      </PrevArrow>
    );
  }

  return (
    <Wrapper theme={theme.widgetLessonPlan}>
      {title && (
        <Title theme={theme.widgetLessonPlan.title}>
          <Image src={Plan} theme={theme.widgetLessonPlan.image} alt='' />
          {title}
        </Title>
      )}
      {data && (
        <SelectContainer theme={theme.widgetLessonPlan.selectContainer}>
          <Text theme={theme.widgetLessonPlan.selectText}>
            <FormattedMessage id='WIDGET_LESSON_PLAN.CHOOSE_GROUP' />
          </Text>
          <Select
            theme={theme.widgetLessonPlan.select}
            value={groupIndex}
            onChange={e => setGroupIndex(e.currentTarget.value)}
          >
            {data.map((item, key) => (
              <Option
                value={key}
                theme={theme.widgetLessonPlan.option}
                key={key}
              >
                {item.title}
              </Option>
            ))}
          </Select>
        </SelectContainer>
      )}
      {data && data[groupIndex].children && (
        <Slider {...sliderOptions}>
          {data[groupIndex].children.map((item, key) => (
            <Item key={key}>
              <Date theme={theme.widgetLessonPlan.date}>{item.title}</Date>
              <Table theme={theme.widgetLessonPlan.table}>
                <Content
                  theme={theme.widgetLessonPlan.content}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.content)
                  }}
                />
              </Table>
            </Item>
          ))}
        </Slider>
      )}
    </Wrapper>
  );
};

export default WidgetLessonPlan;
